<template>
  <div class="login">
    <header>
      <div class="wrapper">
        <img src="../assets/img/logo@2x.png" width="36" height="36">
        <span class="tit">同步课堂</span>
      </div>
    </header>
    <div class="container">
      <div :class="['login-wrapper', 'animate__animated', animateShakeXHas? 'animate__shakeX': '']">
        <a-input v-model="userName" placeholder="请输入用户名">
          <div slot="prefix" class="prefix">
            <img class="prefix-icon" src="../assets/img/login-icon1@2x.png" width="20" height="20">
            <i class="line"></i>
          </div>
        </a-input>
        <a-input-password v-model="password" placeholder="请输入密码" @keyup.enter="handleLogin">
          <div slot="prefix" class="prefix">
            <img class="prefix-icon" src="../assets/img/login-icon2@2x.png" width="20" height="20">
            <i class="line"></i>
          </div>
          <img slot="suffix" src="../assets/img/login-icon2@2x.png" width="20" height="20">
        </a-input-password>
        <p v-if="loginError" class="error-tit">{{errMsg}}</p>
        <div @click="handleLogin" class="login-btn ZHIHUISHU_QZMD">
          登录
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  data(){
    return {
      userName: '',
      password: '',
      errMsg: '',
      loginError: false,
      animateShakeXHas: false
    }
  },
  methods: {
    ...mapMutations('userInfo', {
      Mutation_SET_TOKEN: 'Mutation_SET_TOKEN'
    }),
    handleLogin() {
      this.loginError = false;
      if (!this.userName.trim()) return this.$message.warning("请输入用户名");
      if (!this.password.trim()) return this.$message.warning("请输入密码");
      this.$api.login({userName:this.userName, password:this.password}).then(res => {
        if(res.code === 200) {
          this.Mutation_SET_TOKEN(res.rt);
          this.$message.success("登录成功");
          setTimeout(() => {
            this.$router.push('/');
          }, 500);
        }else{
          this.loginError = true
          this.errMsg = res.msg
          this.animateBounceIn();
        }
      })
    },
    animateBounceIn() {
      this.animateShakeXHas = true
      setTimeout(() => {
        this.animateShakeXHas = false;
      }, 500);
    },
  }
}
</script>
<style lang="scss" scoped>
.login{
  width: 100%;
  height: 100vh;
  header{
    height: 64px;
    background: #1E2C5C;
    .wrapper{
      display: flex;
      align-items: center;
      margin: 0 auto;
      max-width: 1340px;
      height: 64px;
      text-align: left;
      color: #fff;
      .tit{
        margin-left: 14px;
        font-size: 20px;
        font-weight: bolder;
      }
    }
  }
  .container{
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 64px);
    background: url('//image.zhihuishu.com/zhs/ablecommons/zhangying/202107/30b43d6728d541619cab72d18fd34e91.png') no-repeat;
    background-size: cover;
    .login-wrapper{
      position: relative;
      padding: 229px 45px 0;
      width: 430px;
      height: 460px;
      background: url('../assets/img/login-model@2x.png') no-repeat;
      background-size: contain;
      .ant-input-affix-wrapper{
        margin-bottom: 20px;
      }
      .error-tit{
        position: absolute;
        top: 343px;
        left: 45px;
        text-align: left;
        color: #FF6363;
        font-size: 12px;
      }
      .login-btn{
        margin-top: 8px;
        width: 100%;
        height: 44px;
        line-height: 44px;
        background: #3DB166;
        color: #fff;
        border-radius: 4px;
        font-size: 16px;
        cursor: pointer;
        &:active {
          background: #2a7b46;
        }
      }
      ::v-deep{
        .prefix{
          display: flex;
          .prefix-icon{
            margin-right: 14px;
          }
          .line{
            width: 1px;
            background-color: #EDEDED;
          }
        }
        .ant-input{
          padding-left: 57px;
          background: #FAFAFA;
          border: 1px solid #EDEDED;
          border-radius: 0;
          height: 44px;
        }
      }
    }
  }
}
</style>